export default {
  home: "Home",
  book: "Book",
  stock: "Stock",
  outOfStock: "Out of Stock",
  price: "Price",
  addToCart: "Add to Cart",
  downloadAllVideos: "Download All Videos & Clips",
  copied: "Link copied!",
  description: "Description",
  chapters: "Chapters",
  reviews: "Reviews",
  noDescription: "No description available for this product.",
  chaptersPlaceholder: "Chapters content will be placed here.",
  reviewsPlaceholder: "User reviews section will be placed here.",
  noChapters: "No chapters available for this product.",
noMediaInChapter: "No media available in this chapter.",
playAudio: "Play Audio",
watchClip: "Watch Clip",
playGame: "Start Game",
mediaCount: "Items",


commentsTitle: "User Reviews",
noComments: "No reviews yet. Be the first to review this product!",
submitComment: "Submit a Review",
yourRating: "Your Rating",
yourName: "Full Name",
yourComment: "Your Review",
namePlaceholder: "Enter your name",
commentPlaceholder: "Write your review about this product...",
commentSuccess: "Your review was submitted successfully and will be displayed after review.",
sendBtn: "Submit Review",
userFallback: "User",

  toman: "Toman",
  noProducts: "No products found.",
  serverError: "Error connecting to server. Please try again.",
  addToWishlist: "Add to Wishlist",
  removeFromWishlist: "Remove from Wishlist",

  urls: {
    home: "/en",
    ProductCategory: "/en/product-category",
  },
};
